import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: 'current-password' | 'new-password';
  describedBy?: string;
  invalid?: boolean;
}

export default function PasswordField({ id, label, value, onChange, autoComplete = 'new-password', describedBy, invalid }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation('brand');
  return <div>
    <label htmlFor={id} className="field-label">{label}</label>
    <div className="relative">
      <input id={id} name={id} type={visible ? 'text' : 'password'} value={value} onChange={event => onChange(event.target.value)} autoComplete={autoComplete} required className={`input pr-14 ${invalid ? 'input-error' : ''}`} aria-invalid={invalid || undefined} aria-describedby={describedBy} />
      <button type="button" onClick={() => setVisible(!visible)} className="auth-visibility absolute right-1 top-1/2 -translate-y-1/2 rounded-lg p-3 text-[var(--text-secondary)]" aria-label={`${t(visible ? 'hidePassword' : 'showPassword')}: ${label}`} aria-pressed={visible}>{visible ? <EyeOff size={18} /> : <Eye size={18} />}</button>
    </div>
  </div>;
}
